<template>
<div class="page">
    <panel v-if="noJump" :extinfo="extinfo" ref="panel" :wapTitle="''" :appLink="appLink" :spreadID="'0'" :showNav="false" :isDetail="false" @gotoApp="gotoApp"></panel>
    <header v-if="noJump" class="header greenHeader">
        <a href="javascript:;" class="goBack" @click="goBack()" v-if="!isWx && !from"></a>
        <div @click.stop="followFun(info)" class="followBox" :style="info&&info.isFocus==0?'color: #6B6C6C;':'color: #F6344B;'">
            <img v-if="info&&info.isFocus==1" src="../../assets/img/Component 22@2x.png">
            <img v-if="info&&info.isFocus==0" src="../../assets/img/Component 21@2x.png">
        </div>
        <span class="icon_share" @click="alertInfo" v-if="!isWx && from!=1"></span>
        <h3></h3>
    </header>
    <header v-if="!noJump" style="height: 2.2rem; width: 100%; background: #35BD7D"></header>
    <div class="topBg" :style="!noJump?'height: 5rem;':''"></div>
    <div class="speDetail" @click="toSessionDetail">
        <div class="speName">{{ sessName }}</div>

        <div class="speInfo">
            <div v-for="(item, index) in sessData" :key="index">
                <span class="moreBtn" v-if="index == 1"></span>
                <p>{{ item.label }}：{{ item.text }}</p>
            </div>
        </div>
        <div class="imgCenter">
            <div class="bg">
                <img  style="filter: blur(10px);" :src="picUrl" :onerror="errImg" />
            </div>
            <div class="poster">
                <img  :src="picUrl" :onerror="errImg" />
            </div>


        </div>
    </div>
    <!-- <div class="specialSubjectBox" v-if="info.article_list.length>0">
        <div class="subjectBox">
            <div class="subjectContentBox">
                <div class="subjectImg">
                    <img :src="info.article_list[0].cover" alt="">
                </div>
                <div class="subjectTextBox">
                    <div>{{info.article_list[0].title}}</div>
                    <div class="num">{{info.article_list[0].view_num}}阅读</div>
                </div>
            </div>
        </div>

    </div> -->
    <div class="onlineAuction" v-if="isShowOnline">
        <div class="auctionView" @click="onlineClick">
            <span class="auctionTitle">{{onlineTitle}}</span>
            <span class="auctionBtn">参拍 | <i v-if="onlinePerson">| {{onlinePerson}}次围观</i></span>
        </div>
    </div>

    <div class="speList">
        <ul>
            <li @click="toSpecial(item,index)" v-for="(item, index) in sessList" :key="index">
                <dl>
                    <dt>
                        <div class="imgCenter">
                            <!-- <img src="../../assets/img/avator.jpeg" alt="" /> -->
                            <img :src="item.coverPic" alt="" />
                        </div>
                        <span class="num">{{ item.total }}</span>
                        <span class="HDPic" v-if="item.isHD > 0"></span>
                        <template v-if="info.status == 4 || info.status == 5 ||  info.status == 6">
                            <template v-if="item.live_info.have_live > 0">
                                <span class="live" v-if="item.live_info.live_status == 2"></span>
                                <span class="review" v-else-if="item.live_info.status_name ">{{item.live_info.status_name}}</span>
                            </template>
                            <template v-else>
                                <span class="review" v-if="item.live_info.status_name ">{{item.live_info.status_name}}</span>
                            </template>
                        </template>
                    </dt>
                    <dd>
                        <h3>
                            <!--5-结拍 4-拍卖中  3-带预展 2-预展中 1-待拍卖-->
                            <!-- 此处没有加上预展状态 -->
                            <!-- <span :class="status status1"></span -->
                            <span :class="[
                                        'status',
                                        item.status == 1 ? 'status1' : '',
                                        item.status == 4 ? 'status2' : '',
                                        item.status == 5 ? 'status3' : '',
                                        item.status == 2 ? 'status4' : '',
                                        item.status == 3 ? 'status5' : '',
                                        item.status == 6 ? 'status6' : '',
                                    ]">{{item.status == 6 ? '暂停中' : ''}}</span>{{ item.name }}
                        </h3>
                        <div class="tags">
                            <template v-for="(e, index) in item.live_info
                                        .label_list">
                                <template v-if="e.style==1">
                                    <span :key="'tag'+index" class="tagStyle">
                                        {{e.name}}
                                    </span>
                                </template>
                                <template v-else>
                                    <span :key="'tag'+index">
                                        {{e.name}}
                                    </span>
                                </template>

                            </template>

                        </div>

                        <div class="speItem" v-for="(item1, index1) in item.extraInfo" :key="index1">
                            <p :class="['item', 'icon' + Number(++index1)]">
                                {{ item1.text }}
                            </p>
                        </div>
                    </dd>
                </dl>
            </li>
        </ul>
    </div>
    <div class="noMore">
        <span>我是有底线的</span>
    </div>
    <div class="podWrap" @click="podSc()">
        <contact :info="info" :id="sessionCodeId"></contact>
    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <watermark v-if="showWater"></watermark>
</div>
</template>

<script>
import {
    sessionDetail,
    setBidClick
} from "@/api/auction";
import {
    indexFocus
} from "@/api/index";
import {
    mapActions,
    mapGetters
} from "vuex";
import {
    alertInfo,
    getWXConfig
} from "@/assets/js/weixinShare";
import panel from "@/views/preview/component/panel.vue";
import DownLoadApp from "@/components/common/downloadApp";
import contact from "@/components/contact";
import {
    isWeixin
} from "@/api/auction/isWeixin";
import watermark from "@/components/common/watermark";
import {
    Toast
} from "vant";
import {
    scMdFunc,
    gotoLogin
} from "@/assets/js/scData";

export default {
    name: "session",
    data() {
        return {
            waterLink: "",
            noJump: true,
            errImg: 'this.src = "' + require('../../assets/img/topic/default.png') + '"',
            from: this.$route.query.from,
            showWater: false,
            sessData: null, //整个的返回值
            sessName: "",
            sessList: [], //拍卖会列表
            picUrl: "", //图片
            appLink: "/2/3/" + this.$route.params.sessionCode,
            sessionCodeId: this.$route.params.sessionCode,
            isWx: false,
            extinfo:"",
            param: {
                show: 0,
                sessionCode: "",
                // session_inspect_id: null,
                only_meta: 1, //0-全部都拿数据 1-只拿mate 基本信息 2-只拿列表
            },
            info: {
                isFocus: '',
                article_list: []

            },
            onlineTitle: '',
            onlineUrl: '',
            isShowOnline: false,
            companyName: '',
            onlinePerson: 0,
        };
    },
    created() {
        this.waterLink = "";
        // 判断下载app的是否显示
        if (this.$route.query.from && this.from == 1) {
            this.noJump = false;
        }
    },
    mounted() {

        var isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
        var isToutiaoApp = (/(SwiftToutiao|ArtronToutiao|ArtExpress)/g).test(window.navigator.userAgent)
        if (isTuluApp || isToutiaoApp) {
            this.noJump = false
        }
        if (
            (this.$route.query.from && this.$route.query.from == 1) ||
            (this.$route.query.from && this.$route.query.from == 2)
        ) {
            this.showWater = true;
            this.waterLink = this.$route.query.from;
        }
        if (isWeixin()) {
            this.isWx = true;
        }
        // console.log("this.getIsLoadIng", this.getIsLoadIng);
        // //接口调用
        if (!this.getIsLoadIng) {
            this.param.sessionCode = this.$route.params.sessionCode;
            this.param.only_meta = 1;
            if (this.$route.query.from && this.$route.query.from == 1) {
                this.param.show = 1;
                this.param.session_inspect_id = this.$route.query.sessiion_inspect_id;
            }
            this.getSessionDetail([
                this.param,
                () => {
                    this.filteData();
                },
            ]);
        } else {
            this.param.sessionCode = this.$route.params.sessionCode;
            this.param.only_meta = 1;

            this.filteData();
        }
        let that = this;
        that.extinfo=JSON.stringify({url: "session",param: that.$route.params.sessionCode})
        // this.getOnLineAuction();

    },

    //服务端渲染
    asyncData({
        store,
        route
    }) {
        var param = {};
        if (route.query.from && route.query.from == 1) {
            param = {
                sessionCode: route.params.sessionCode,
                only_meta: 1, //取mate信息
                show: 1,
                session_inspect_id: route.query.sessiion_inspect_id,
            };
        } else {
            param = {
                sessionCode: route.params.sessionCode,
                only_meta: 1, //取mate信息
            };
        }

        return store.dispatch("sessionPage/getSessionDetail", [
            param,
            null,
            () => {},
        ]);
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "sessionPage/getIsLoadIng",
            getData: "sessionPage/getData",
        }),
    },
    methods: {
        ...mapActions({
            getSessionDetail: "sessionPage/getSessionDetail",
        }),
        followFun(e) {
            let parmas = {
                special_type: 4,
                action: e.isFocus == 0 ? 1 : 2,
                code: e.organCode,
            }
            scMdFunc('allClick', {
                cur_page: '33',
                cur_moudle: '33-1',
                cur_button: '33-1-1',
            })
            if (!e.isLogin) { //未登录
                gotoLogin()
            } else {
                indexFocus(parmas).then((res) => {
                    if (res.code == 0) {
                        if (e.isFocus == 0) {
                            this.$toast('关注成功')
                        }

                        e.isFocus = e.isFocus == 0 ? 1 : 0;

                    }
                })
            }

        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        goBack() {
            // this.$router.push({
            //     path: "/"
            // });
            if (document.referrer) {
                window.location.href = document.referrer
            } else if (window.history.state) {
                this.$router.back()
            } else if (this.$route.query.fromlink) {
                window.location.href = decodeURIComponent(this.$route.query.fromlink)
            } else {
                this.$router.push({
                    path: "/"
                });
            }
        },
        podSc() {
            scMdFunc('allClick', {
                cur_page: '33',
                cur_moudle: '33-4',
                cur_button: '33-4-1',
            })
        },
        // 顶部跳转拍卖公司/名称
        toSessionDetail() {
            scMdFunc('allClick', {
                cur_page: '33',
                cur_moudle: '33-2',
                cur_button: '33-2-1',
            })
            if (this.$route.query.from == 1 && this.$route.query.from) {
                return false
            } else {
                this.$router.push({
                    name: "session_detail",
                    query: {
                        sessionCode: this.$route.params.sessionCode,
                        from: this.waterLink,
                    },
                });
            }
        },
        alertInfo() {
            scMdFunc('allClick', {
                cur_page: '33',
                cur_moudle: '33-1',
                cur_button: '33-1-2',
            })

            alertInfo("分享时请使用浏览器自身的分享工具");
        },
        // 路由跳转
        toSpecial(item,i) {
            scMdFunc('allClick', {
                cur_page: '33',
                cur_moudle: '33-3',
                cur_button: '33-3-'+ (Number(i) + 1),
            })
            if (this.$route.query.from == 1 && this.$route.query.from) {
                return false
            } else {
                this.$router.push({
                    path: "/special/" + item.specialCode,
                    query: {
                        from: this.waterLink
                    },
                });
            }

        },
        filteData() {
            // this.sessData = this.$store.state["sessionPage"]["data"].extraInfo;
            // // 本次拍卖名称
            // this.sessName = this.$store.state["sessionPage"]["data"].name;
            // this.picUrl = this.$store.state["sessionPage"]["data"].picUrl;
            // // 拍卖列表
            // this.sessList =
            //     this.$store.state["sessionPage"]["data"].specialsList;
            // 微信分享功能+title
            let dome = this.$store.state["sessionPage"]["data"];
            this.info = dome
            
            document.title = dome.shareMessage ? dome.shareMessage.title : "";
            // let head = document.getElementsByTagName("head");
            // if (!document.querySelector("meta[name=description]")) {
            //     let meta = document.createElement("meta");
            //     meta.name = "description";
            //     meta.content = dome.meta ? dome.meta.description : "";
            //     head[0].appendChild(meta);
            // } else {
            //     document
            //         .querySelector("meta[name=description]")
            //         .setAttribute(
            //             "content",
            //             dome.meta ? dome.meta.description : ""
            //         );
            // }
            this.getsessionDetail();
            
        },
        // 调取接口
        getsessionDetail() {
            let that = this
            this.param.sessionCode = this.$route.params.sessionCode;
            this.param.only_meta = 0;
            if (this.$route.query.from && this.$route.query.from == 1) {
                this.param.show = 1;
                this.param.session_inspect_id = this.$route.query.sessiion_inspect_id;
            }
            sessionDetail(this.param).then((res) => {
                if (res.code == 0) {
                    // 全部属性
                    this.info = res.data
                    this.sessData = res.data.extraInfo;
                    this.sessData.forEach((item) => {
                        if (item.label === '拍卖公司') {
                            this.companyName = item.text
                        }
                    })
                    // 本次拍卖名称
                    this.sessName = res.data.name;
                    this.picUrl = res.data.picUrl;
                    // 拍卖列表
                    this.sessList = res.data.specialsList;
                    if (this.info.catalog_info_new && this.info.catalog_info_new.length) {
                        let catalog = this.info.catalog_info_new[0];
                        this.isShowOnline = true;
                        this.onlineTitle = catalog.title;
                        this.onlineUrl = catalog.link;
                        this.onlinePerson = res.data.bid_click_num;
                    }
                window.AFedWxShareData = {
                    title:  this.info.shareMessage ?  this.info.shareMessage.title : "",
                    imgUrl:  this.info.shareMessage.pic ||
                        "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
                    desc:  this.info.shareMessage.desc || "",
                    link: window.location.href,
                };
                getWXConfig(window.AFedWxShareData);
                if (this.$route.query.scFrom && this.$route.query.scFrom.split("-").length == 5) {
                            scFromList = this.$route.query.scFrom.split("-")
                            scMdFunc('allPageView', {
                                from_page: scFromList[0],
                                from_module: scFromList[0] + '-' + scFromList[1],
                                from_button: scFromList[0] + '-' + scFromList[1] + '-' + scFromList[2],
                                from_page_pk: this.$route.query.scId || '',
                                cur_page: '33',
                                magnification:Math.floor(Math.random() * (13 - 7 + 1)) + 7,
                            })
                        } else {
                            scMdFunc('allPageView', {
                                cur_page: '33',
                                magnification:Math.floor(Math.random() * (13 - 7 + 1)) + 7,
                            })
                        }

                } else {
                    Toast({
                        message: '该内容不存在～',
                        duration: 2000,
                        onClose: function () {
                            that.$router.push({
                                path: '/',
                                query: {
                                    from: that.$route.query.from
                                }
                            })
                        }
                    })
                }
            });
        },
        onlineClick() {
            let params = {
                specialCode: this.$route.params.sessionCode
            }
            setBidClick(params).then(res => {
                if (res.code == 0) {
                    // this.onlinePerson = res.data.bid_click_num;
                }
            });
            setTimeout(() => {
                window.location.href = this.onlineUrl;
            }, 500)

        },
        // getOnLineAuction(){
        //     let params={
        //         code: this.$route.params.sessionCode
        //     }
        //     onlineAuction(params).then((res)=>{
        //         let data=res.data;
        //         if(data.catalog&&data.catalog.length){
        //             let catalog=data.catalog[0];
        //             this.isShowOnline=true;
        //             this.onlineTitle=catalog.title;
        //             this.onlineUrl=catalog.link;
        //         }
        //     })
        // }
    },
    components: {
        panel,
        DownLoadApp,
        watermark,
        contact
    },
};
</script>

<style lang="scss" scoped>
@import url("../../assets/css/reset.css");
@import url("../../assets/css/swiper.css");

.header {
    height: 2.2rem;
    background: #ffffff;
    position: relative;
}

.greenHeader {
    background: rgba(0,0,0,0);
    z-index: 2;
}

.specialSubjectBox {
    background-image: linear-gradient(#35BD7D, #fff);
    width: 100%;
}

.subjectBox {
    width: 100%;
    background: #fff;
    border-top-right-radius: 1rem;
    border-top-left-radius: 1rem;
    padding: 0.6rem 0.6rem 0.2rem 0.6rem;
}

.subjectContentBox {
    height: 52px;
    background: #F7F8F9;
    border-radius: 6px 6px 6px 6px;
    overflow: hidden;
    padding: 6px;
    box-sizing: border-box;
}

.subjectImg {
    width: 71px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    overflow: hidden;
    display: inline-block;
}

.subjectImg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.subjectTextBox {
    display: inline-block;
    font-size: 0.65rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    /* line-height: 16px; */
    vertical-align: top;
}

.subjectTextBox .num {
    font-size: 0.55rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #949596;
    line-height: 20px;
}

.header h3 {
    margin-left: 2.2rem;
    margin-right: 2.2rem;
    text-align: center;
    font-size: 0.9rem;
    line-height: 2.2rem;
    color: #27282d;
}

.header .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/Frame585_new@2x.png) no-repeat;
    background-size: cover;
}

.header .icon_share {
    width: 2.2rem;
    height: 2.2rem;
    float: right;
    background: url("../../assets/img/share_new@2x.png") no-repeat;
    background-size: cover;
}

.greenHeader .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/Frame585_new@2x.png) no-repeat;
    background-size: cover;
}

.page {
    width: 18.75rem;
    margin: 0 auto;
}
.topBg{
    width: 100%;
    height: 9rem;
    background: url(../../assets/img/Group437@2x.png) no-repeat;
    background-size: cover;
    position: absolute;
    top: 0;
    z-index: 0;
}
.speDetail {
    position: relative;
    margin-top: -1px;
}

.speDetail .imgCenter {
    display: flex;
    width: 4rem;
    height: 4rem;
    background: #ffffff;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0rem 0rem 0.35rem 0rem rgba(0, 0, 0, 0.35);
    position: absolute;
    top: 0;
    left: 0.5rem;
}

.speDetail .imgCenter .bg{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transform: scale(1.2);
}
.speDetail .imgCenter .poster{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
}
.speDetail .imgCenter img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.speDetail .speName {
    padding-left: 5.35rem;
    padding-right: 2.75rem;
    // height: 1.15rem;
    margin-bottom: 0.5rem;
    // background: #35BD7D;
    font-size: 0.8rem;
    font-weight: 400;
    color: #000;
    line-height: 1.1rem;
}

.followBox {

    position: absolute;
    right: 2.3rem;
    top: 0.5rem;

    img {
        width: 1.2rem;
        vertical-align: top;
    }

}

.speDetail .speInfo {
    position: relative;
    padding-top: 0.4rem;
    padding-bottom: 0.3rem;
    padding-left: 5.35rem;
    padding-right: 1.55rem;
    border-top-right-radius: 2rem;
    border-top-left-radius: 2rem;
    background: #fff;
    font-size: 0.55rem;
    font-weight: 400;
    color: #949596;
    line-height: 0.9rem;
}

.speDetail .speInfo p {
    margin-bottom: 0.25rem;
    overflow: hidden; //多出部分隐藏
    white-space: nowrap; //一行显示
    text-overflow: ellipsis; //是否显示省略号
}

.speDetail .speInfo .moreBtn {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    margin-top: -0.4rem;
    width: 0.8rem;
    height: 0.8rem;
    background: url(../../assets/img/right_arrow@2x.png) no-repeat;
    background-size: cover;
}

.speBox {
    margin-top: 0.25rem;
    background: #ffffff;
    padding-bottom: 0.5rem;
}

.speBox .swiper-slide {}

.speBox .swiper-slide li {
    height: 2.3rem;
    padding: 0 0.6rem 0 0.75rem;
}

.speBox .swiper-slide a {
    display: block;
    height: 100%;
    position: relative;
}

.speBox .swiper-slide .icon {
    position: absolute;
    top: 0.55rem;
    left: 0;
    width: 1.2rem;
    height: 1.2rem;
    background: url(../../assets/img/icon_pai@2x.png) no-repeat;
    background-size: cover;
}

.speBox .swiper-slide .text {
    display: block;
    width: 13rem;
    margin: 0 auto;
    font-size: 0.7rem;
    line-height: 2.3rem;
    color: #27282e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.speBox .swiper-slide .button {
    position: absolute;
    right: 0.6rem;
    top: 0.65rem;
    width: 2.2rem;
    height: 1rem;
    background: #ffffff;
    border-radius: 0.53rem;
    border: 0.03rem solid #18bd6f;
    text-align: center;
    line-height: 1rem;
    font-size: 0.6rem;
    color: #18bd6f;
}

.speBox .swiper-pagination {
    position: relative;
}

/deep/ .speBox .swiper-pagination-bullet {
    width: 0.2rem;
    height: 0.2rem;
    background: #dddee3;
    opacity: 1;
}

/deep/ .speBox .swiper-pagination-bullet-active {
    width: 0.6rem;
    border-radius: 0.1rem;
    background: #18bd6f;
}

/deep/ .speBox.swiper-container-horizontal>.swiper-pagination-bullets {
    bottom: 0;
}

.speList {
    background: #ffffff;
}

.speList ul {
    padding: 0 0.75rem;
}

.speList li {
    padding: 0.75rem 0;
    border-bottom: 0.05rem solid #dddee3;
}

.speList li:last-child {
    border-bottom: none;
}

.speList li dt {
    width: 3.75rem;
    height: 5rem;
    border-radius: 0.2rem;
    overflow: hidden;
    position: relative;
    float: left;
}

.speList li dt .imgCenter {
    width: 100%;
    height: 100%;
    display: flex;
    background: #f5f5f5;
}

.speList li dt .imgCenter img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.speList li dd {
    margin-left: 4.25rem;
}

.speList li dd h3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 0.8rem;
    line-height: 1.1rem;
    color: #27282d;
    min-height: 1.7rem;
}

.speList li dd h3 .status {
    width: 1.9rem;
    height: 0.7rem;
    display: inline-block;
    vertical-align: -0.1rem;
    margin-right: 0.2rem;
}

// 待拍卖
.speList li dd h3 .status1 {
    background: url(../../assets/img/icon_list_tag_green@2x.png) no-repeat;
    background-size: cover;
}

// 拍卖中
.speList li dd h3 .status2 {
    background: url(../../assets/img/icon_list_tag_red@2x.png) no-repeat;
    background-color: rgba(235, 81, 100, 0.10);
    background-position: center;
    background-size: 80% 70%;
    height: 0.8rem;
}

// 已结拍
.speList li dd h3 .status3 {
    background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
    background-color: rgba(188, 189, 190, 0.20);
    background-position: center;
    background-size: 80% 70%;
    height: 0.8rem;
}

// 预展中
.speList li dd h3 .status4 {
    background: url(../../assets/img/icon_list_tag_green.png) no-repeat;
    background-color: rgba(54, 153, 114, 0.10);
    background-position: center;
    background-size: 80% 70%;
    height: 0.8rem;
}

// 待预展
.speList li dd h3 .status5 {
    background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
    background-color: rgba(188, 189, 190, 0.20);
    background-position: center;
    background-size: 80% 70%;
    height: 0.8rem;
}
// 暂停
.speList li dd h3 .status6 {
    background: #F2F2F2;
    text-align: center;
    color: #34886B;
    font-size: 0.55rem;
    line-height: .9rem;
    height: 0.8rem;
    vertical-align: 0;
}
.speList li dd .tags {
    margin-top: 0.3rem;
    // height: 0.9rem;
    font-size: 0;
}

.speList li dd .tags span {
    padding: 0 0.2rem;
    height: 0.9rem;
    display: inline-block;
    border-radius: 0.1rem;
    border: 0.03rem solid #d8d8d8;
    font-size: 0.55rem;
    color: #969696;
    line-height: 0.9rem;
    margin-right: 0.3rem;
}
.speList li dd .tags .tagStyle {
    color: #FFFFFF;
    border: 0;
    background: linear-gradient( 87deg, #FB9C57 0%, #F22C2C 100%), rgba(0,155,95,0.05);  
}


.speList li dd .speItem {
    font-size: 0.65rem;
    color: #969696;
    line-height: 0.9rem;
}

.speList li dl {
    overflow: hidden;
}

.speList li dd .speItem .item {
    margin-bottom: 0.15rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 0.95rem;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 0.65rem;
}

.speList li dd .speItem:last-child .item {
    margin-bottom: 0;
}

.speList li dd .speItem .icon1 {
    background-image: url(../../assets/img/icon_lot.png);
}

.speList li dd .speItem .icon2 {
    background-image: url(../../assets/img/icon_clock.png);
}

.speList li dd .speItem .icon3 {
    background-image: url(../../assets/img/icon_list_add_light@2x.png);
}

.speList li dt .num {
    position: absolute;
    top: 0.2rem;
    left: 0.2rem;
    padding: 0 0.2rem;
    border-radius: 0.1rem;
    background: #101415;
    font-size: 0.6rem;
    line-height: 0.75rem;
    color: #ffffff;
}

.speList li dt .HDPic {
    position: absolute;
    top: 0;
    right: 0;
    width: 1.3rem;
    height: 0.6rem;
    background: url(../../assets/img/hd_list_icon.png) no-repeat;
    background-size: 100% 100%;

}

.speList li dt .live {
    position: absolute;
    bottom: 0;
    left: 0;

    width: 100%;
    height: 1rem;
    background: #18bd6f url(../../assets/img/live.gif) no-repeat;
    font-size: 0.55rem;
    line-height: 1rem;
    background-size: cover;
    color: #ffffff;
}

.speList li dt .review {
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: center;
    width: 100%;
    height: 1rem;
    background: rgba(0, 0, 0, 0.85);
    font-size: 0.55rem;
    line-height: 1rem;
    color: #ffffff;
}

.onlineAuction {
    background: #ffffff;
    padding: 0 0.65rem 0.25rem;
    border-top: 1px solid #F8F8F8;
    border-bottom: 1px solid #F8F8F8;
}

.onlineAuction .auctionView {
    display: block;
    line-height: 1.2rem;
    font-size: .7rem;
    background: url(../../assets/img/icon_pai@2x.png) no-repeat 0 center;
    background-size: auto 1.2rem;
    font-family: Helvetica, STHeiTi, Arial, sans-serif;
    padding: 0.55rem 0 0.55rem 1.45rem;
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
}

.onlineAuction .auctionView .auctionTitle {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
}

.onlineAuction .auctionView .auctionBtn {
    display: inline-block;
    border: 0.03rem solid #18BD6F;
    border-radius: 0.6rem;
    text-align: center;
    font-size: .5rem;
    color: #18BD6F;
    padding: 0 0.5rem;
    white-space: nowrap;
    min-width: 2.2rem;
}

.podWrap {
    position: fixed;
    right: 0;
    bottom: 5.35rem;
    width: 3.2rem;
    height: 6.4rem;
    background: transparent;
    z-index: 30;
}
</style>
